// const env = {
//     url: 'http://localhost:8000/',
//     api: 'http://localhost:8000/api/v1/',
//     baseUrl: 'http://localhost:8080/',
//     title: 'AXS Consultoria',
// }


const env = {
    baseUrl: 'https://assetaxs.com/',
    url: 'https://api.assetaxs.com/',
    api: 'https://api.assetaxs.com/api/v1/',
    title: 'Asset AXS Consultoria',
}



export default env;